
export default {
    name: 'ContentPage',
}
